export const CLINIC_NAMES = {
  GMHNY: "Greater Mental Health NY",
  ACCESS: "Access: Supports for Living",
  LEXINGTON: "Lexington Center for Recovery",
};

export const PROGRAM_NAMES = {
  PEER: "isPeerRequested",
  TELEHEALTH: "isTelehealth",
  INJECTABLE: "isInjectable",
  MINOR: "isMinor",
  CTI: "isCTI",
  IOP: "isIOP",
  PROS: "isPROS",
  PARTIAL_HOSPITAL: "isPartialHospital",
  ON_TRACK: "isOnTrack",
  DAY_REHAB: "isDayRehab",
  MAT: "isMAT",
  OTP: "isOTP",
};

export const USER_TYPES = {
  ADMIN: 0,
  LOCATION: 1,
  CLINIC: 2,
  PEER: 3,
};

export const INSURANCE_OPTIONS = {
  MVP: "MVP",
  FIDELIS: "Fidelis",
  UNITED: "UnitedHealthCare",
  MOLINA: "Molina HealthCare",
  HEALTH_FIRST: "HealthFirst",
  PARTNERS: "Partners Health Plan",
  AETNA: "Aetna",
  MEDICAID: "Medicaid",
  MANAGED_MEDICAID: "Managed Medicaid",
  MEDICARE: "Medicare",
  BCBS: "Blue Cross Blue Shield",
};

export const ZIP_CODES = {
  DUTCHESS: [
    "10516",
    "12501",
    "12504",
    "12506",
    "12507",
    "12508",
    "12510",
    "12511",
    "12512",
    "12514",
    "12522",
    "12524",
    "12527",
    "12531",
    "12533",
    "12537",
    "12538",
    "12540",
    "12545",
    "12546",
    "12564",
    "12567",
    "12569",
    "12570",
    "12571",
    "12572",
    "12574",
    "12578",
    "12580",
    "12581",
    "12582",
    "12583",
    "12585",
    "12590",
    "12592",
    "12594",
    "12601",
    "12602",
    "12603",
    "12604",
  ],
  ORANGE: [
    "10910",
    "10912",
    "10914",
    "10915",
    "10916",
    "10917",
    "10918",
    "10919",
    "10921",
    "10922",
    "10924",
    "10925",
    "10926",
    "10928",
    "10930",
    "10932",
    "10933",
    "10940",
    "10941",
    "10943",
    "10949",
    "10950",
    "10953",
    "10958",
    "10959",
    "10963",
    "10969",
    "10973",
    "10974",
    "10975",
    "10979",
    "10981",
    "10985",
    "10987",
    "10988",
    "10990",
    "10992",
    "10996",
    "10997",
    "10998",
    "12518",
    "12520",
    "12542",
    "12543",
    "12549",
    "12550",
    "12551",
    "12552",
    "12553",
    "12555",
    "12566",
    "12575",
    "12577",
    "12584",
    "12586",
    "12589",
    "12721",
    "12729",
    "12746",
    "12771",
    "12780",
    "12785",
  ],
  PUTNAM: [
    "10509",
    "10512",
    "10516",
    "10524",
    "10537",
    "10541",
    "10542",
    "10560",
    "10579",
    "12524",
    "12531",
    "12533",
    "12563",
    "12564",
    "12582",
  ],
  ROCKLAND: [
    "10901",
    "10911",
    "10913",
    "10920",
    "10923",
    "10927",
    "10931",
    "10952",
    "10954",
    "10956",
    "10960",
    "10962",
    "10964",
    "10965",
    "10968",
    "10970",
    "10974",
    "10976",
    "10977",
    "10980",
    "10982",
    "10983",
    "10984",
    "10986",
    "10987",
    "10989",
    "10993",
    "10994",
  ],
  SULLIVAN: [
    "10940",
    "12428",
    "12458",
    "12566",
    "12701",
    "12719",
    "12720",
    "12721",
    "12722",
    "12723",
    "12724",
    "12725",
    "12726",
    "12727",
    "12729",
    "12732",
    "12733",
    "12734",
    "12736",
    "12737",
    "12738",
    "12740",
    "12741",
    "12742",
    "12743",
    "12745",
    "12747",
    "12748",
    "12749",
    "12750",
    "12751",
    "12752",
    "12754",
    "12758",
    "12759",
    "12760",
    "12762",
    "12763",
    "12764",
    "12765",
    "12766",
    "12767",
    "12768",
    "12769",
    "12770",
    "12775",
    "12776",
    "12777",
    "12778",
    "12779",
    "12780",
    "12781",
    "12783",
    "12784",
    "12786",
    "12787",
    "12788",
    "12789",
    "12790",
    "12791",
    "12792",
  ],
  ULSTER: [
    "12401",
    "12402",
    "12404",
    "12406",
    "12409",
    "12410",
    "12411",
    "12412",
    "12414",
    "12416",
    "12417",
    "12419",
    "12420",
    "12428",
    "12429",
    "12432",
    "12433",
    "12435",
    "12440",
    "12441",
    "12443",
    "12446",
    "12448",
    "12449",
    "12453",
    "12456",
    "12457",
    "12458",
    "12461",
    "12463",
    "12464",
    "12465",
    "12466",
    "12471",
    "12472",
    "12475",
    "12477",
    "12480",
    "12481",
    "12483",
    "12484",
    "12486",
    "12487",
    "12489",
    "12490",
    "12491",
    "12493",
    "12494",
    "12495",
    "12498",
    "12515",
    "12525",
    "12528",
    "12542",
    "12547",
    "12548",
    "12561",
    "12566",
    "12568",
    "12586",
    "12588",
    "12589",
    "12725",
    "12740",
    "12758",
    "12763",
  ],
  WESTCHESTER: [
    "10470",
    "10501",
    "10502",
    "10503",
    "10504",
    "10505",
    "10506",
    "10507",
    "10509",
    "10510",
    "10511",
    "10514",
    "10517",
    "10518",
    "10519",
    "10520",
    "10521",
    "10522",
    "10523",
    "10524",
    "10526",
    "10527",
    "10528",
    "10530",
    "10532",
    "10533",
    "10535",
    "10536",
    "10537",
    "10538",
    "10540",
    "10541",
    "10543",
    "10545",
    "10546",
    "10547",
    "10548",
    "10549",
    "10550",
    "10551",
    "10552",
    "10553",
    "10557",
    "10558",
    "10560",
    "10562",
    "10566",
    "10567",
    "10570",
    "10571",
    "10572",
    "10573",
    "10576",
    "10577",
    "10578",
    "10579",
    "10580",
    "10583",
    "10587",
    "10588",
    "10589",
    "10590",
    "10591",
    "10594",
    "10595",
    "10596",
    "10597",
    "10598",
    "10601",
    "10602",
    "10603",
    "10604",
    "10605",
    "10606",
    "10607",
    "10610",
    "10701",
    "10702",
    "10703",
    "10704",
    "10705",
    "10706",
    "10707",
    "10708",
    "10709",
    "10710",
    "10801",
    "10802",
    "10803",
    "10804",
    "10805",
  ],
};
